package com.devi3east.bashbuddy.features.events.detail.responses

import com.devi3east.bashbuddy.features.events.common.data.models.Event
import com.devi3east.bashbuddy.features.events.common.data.models.Ticket
import kotlinx.serialization.Serializable

@Serializable
data class EventDetailResponse(
    val event: Event,
    val tickets: List<Ticket> = emptyList()
)